var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "privacy 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.9521 12.5479L50.4521 4.21459C50.1542 4.14999 49.8458 4.14999 49.5479 4.21459L12.0479 12.5479C11.5849 12.6508 11.1709 12.9087 10.8743 13.2787C10.5777 13.6488 10.4163 14.1091 10.4167 14.5833V56.25C10.4167 66.7482 14.587 76.8163 22.0104 84.2396C29.4337 91.663 39.5018 95.8333 50 95.8333C60.4982 95.8333 70.5663 91.663 77.9896 84.2396C85.413 76.8163 89.5833 66.7482 89.5833 56.25V14.5833C89.5837 14.1091 89.4223 13.6488 89.1257 13.2787C88.8291 12.9087 88.4151 12.6508 87.9521 12.5479ZM68.75 68.75C68.75 69.3025 68.5305 69.8324 68.1398 70.2231C67.7491 70.6138 67.2192 70.8333 66.6667 70.8333H33.3333C32.7808 70.8333 32.2509 70.6138 31.8602 70.2231C31.4695 69.8324 31.25 69.3025 31.25 68.75V47.9167C31.25 47.3641 31.4695 46.8342 31.8602 46.4435C32.2509 46.0528 32.7808 45.8333 33.3333 45.8333H39.5833V35.4167C39.5833 32.654 40.6808 30.0045 42.6343 28.051C44.5878 26.0975 47.2373 25 50 25C52.7627 25 55.4122 26.0975 57.3657 28.051C59.3192 30.0045 60.4167 32.654 60.4167 35.4167V45.8333H66.6667C67.2192 45.8333 67.7491 46.0528 68.1398 46.4435C68.5305 46.8342 68.75 47.3641 68.75 47.9167V68.75Z",
    fill: "#C3CAD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50 29.1666C48.3424 29.1666 46.7527 29.8251 45.5806 30.9972C44.4085 32.1693 43.75 33.759 43.75 35.4166V45.8333H56.25V35.4166C56.25 33.759 55.5915 32.1693 54.4194 30.9972C53.2473 29.8251 51.6576 29.1666 50 29.1666Z",
    fill: "#C3CAD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50 62.5C52.3012 62.5 54.1667 60.6345 54.1667 58.3333C54.1667 56.0321 52.3012 54.1666 50 54.1666C47.6988 54.1666 45.8333 56.0321 45.8333 58.3333C45.8333 60.6345 47.6988 62.5 50 62.5Z",
    fill: "#C3CAD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.21c3c9487cacd46d1e9b82c6f770f82a.svg";
export { ForwardRef as ReactComponent };